var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlagCondition from 'components/common/flag-condition/FlagCondition';
import { RadioMenu } from 'components/common/select-menu';
import ReportInsightCard from 'components/common/report-insight-card/ReportInsightCard';
import { ChartType } from 'components/report-pie-chart/ReportPieChart';
import { ANALYTIC_FEATURES, CW_ENGAGEMENT_CARD_ID, FeatureFlagNames, SORT_DIRECTION } from 'constants/app.constant';
import { ASSIGNMENT_SUMMARY_TABLE_SELECTOR, ENGAGEMENT_TABLE_CARD_SORT_CONFIG, INTERACTION_BETWEEN_CARD_AND_TABLE, REPORT_TABLE_ID } from 'reports/cw/constants/report.constant';
import { pluralizeUnit } from 'helpers/ui.helper';
import AssignmentTypeIcon from 'reports/cw/components/common/assignment-type-icon/AssignmentTypeIcon';
import { cwActions, cwSelectors } from 'reports/cw/redux/ducks/cw';
import { appSelectors } from 'redux/ducks/app';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { ENGAGEMENT_TABS } from '../Engagement';
import EngagementInsightCardList from './engagement-insight-card/EngagementInsightCardList';
var EngagementHeader = /** @class */ (function (_super) {
    __extends(EngagementHeader, _super);
    function EngagementHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildPercentValueElement = function (percent) {
            return <span className="u-els-bold c-cw-information-card__value-data">{"".concat(percent, "%")}</span>;
        };
        _this.buildCardProps = function () {
            var _a = _this.props, assignmentEngagement = _a.assignmentEngagement, isAssignmentEngagementReportLoading = _a.isAssignmentEngagementReportLoading, isStudentEngagementReportLoading = _a.isStudentEngagementReportLoading;
            var _b = assignmentEngagement.cardData, completedAssignments = _b.completedAssignments, classAvgScore = _b.classAvgScore, totalAssignments = _b.totalAssignments, totalStudents = _b.totalStudents, pastDueStudents = _b.pastDueStudents, belowClassAvgStudents = _b.belowClassAvgStudents, inProgressAssignment = _b.inProgressAssignment;
            var cards = [
                {
                    id: CW_ENGAGEMENT_CARD_ID.numberOfStudentsWithPastDue,
                    icon: 'AlarmClock',
                    title: '# Students with Past Due',
                    subtitle: 'View students with past due assignments',
                    value: pastDueStudents,
                    total: totalStudents,
                    clickable: true,
                    isLoading: isStudentEngagementReportLoading,
                    chartConfig: {
                        type: ChartType.HALF,
                        value: pastDueStudents,
                        total: totalStudents,
                        fillColorClass: 'u-els-fill-warn'
                    },
                    mainAriaLabel: 'Number students with past due card',
                    footerAriaLabel: 'Click to scroll down to the Student Engagement table and the Past Due Column will be sorted in descending order',
                    className: 'c-cw-engagement-header__student-with-past-due-card',
                    showTitleInfoIcon: true
                }
            ];
            cards = __spreadArray([
                {
                    id: CW_ENGAGEMENT_CARD_ID.classAverageScore,
                    icon: 'Performance',
                    title: 'Class Average Score',
                    subtitle: "".concat(belowClassAvgStudents, " ").concat(pluralizeUnit(belowClassAvgStudents, 'student'), " below class average"),
                    customValueElement: _this.buildPercentValueElement(+(classAvgScore * 100).toFixed(0)),
                    clickable: true,
                    isLoading: isStudentEngagementReportLoading,
                    chartConfig: {
                        type: ChartType.FULL,
                        value: +(classAvgScore * 100).toFixed(0),
                        total: 100,
                        fillColorClass: 'u-els-fill-extended-teal-7'
                    },
                    mainAriaLabel: 'Class average score card',
                    footerAriaLabel: 'Click to scroll down to the Student Engagement table and the Student Average Score column will be sorted in ascending order',
                    className: 'c-cw-engagement-header__class-avg-score-card',
                    customFooter: null,
                    showTitleInfoIcon: true
                },
                {
                    id: CW_ENGAGEMENT_CARD_ID.assignmentCompleted,
                    icon: 'DocumentCheck',
                    title: 'Completed Assignments',
                    subtitle: "".concat(inProgressAssignment, " ").concat(pluralizeUnit(inProgressAssignment, 'assignment'), " in progress"),
                    value: completedAssignments,
                    total: totalAssignments,
                    clickable: true,
                    isLoading: isAssignmentEngagementReportLoading,
                    chartConfig: {
                        type: ChartType.HALF,
                        value: completedAssignments,
                        total: totalAssignments,
                        fillColorClass: 'u-els-fill-extended-blue-9'
                    },
                    mainAriaLabel: 'Completed assignment card',
                    footerAriaLabel: 'Click to scroll down to the Assignment Engagement table and the Completion column will be sorted in descending order',
                    className: 'c-cw-engagement-header__completed-assignment-card',
                    customValueElement: null,
                    customFooter: null,
                    showTitleInfoIcon: true
                }
            ], cards, true);
            return cards;
        };
        _this.handleLowCompletionNavigate = function () {
            _this.props.trackAAFeature(ANALYTIC_FEATURES[CW_ENGAGEMENT_CARD_ID.assignmentsBelowCompletionThreshold]);
            _this.props.setAssignmentSummaryCardAndTableSortInteraction({
                sortDirection: SORT_DIRECTION.ASC,
                columnHeaderSelector: ASSIGNMENT_SUMMARY_TABLE_SELECTOR.percentCompletedColumn,
                field: 'percentComplete'
            });
        };
        _this.handleSubTitleClick = function (id) {
            var studentIdx = ENGAGEMENT_TABS.student.index, assignmentIdx = ENGAGEMENT_TABS.assignment.index;
            _this.props.trackAAFeature(ANALYTIC_FEATURES[id]);
            var getProps = function (sortDirection, columnHeaderSelector, field) {
                return {
                    sortDirection: sortDirection,
                    columnHeaderSelector: columnHeaderSelector,
                    field: field
                };
            };
            var isUpdatedUiEnabled = isFeatureEnabled(_this.props.featureFlags, FeatureFlagNames.CW_UPDATED_UI_ENABLED);
            var engagementTableSortConfig = ENGAGEMENT_TABLE_CARD_SORT_CONFIG[id];
            if (isUpdatedUiEnabled && engagementTableSortConfig) {
                var headerSelector_1 = engagementTableSortConfig.headerSelector, field_1 = engagementTableSortConfig.field, sortDirection_1 = engagementTableSortConfig.sortDirection, manualSort = engagementTableSortConfig.manualSort;
                _this.props.setStudentEngagementSort(__assign(__assign({}, getProps(sortDirection_1, headerSelector_1, field_1)), { manualSort: manualSort }));
                return;
            }
            var _a = INTERACTION_BETWEEN_CARD_AND_TABLE[id], _b = _a.tableColumn, table = _b.table, field = _b.field, headerSelector = _b.headerSelector, sortDirection = _a.sortDirection;
            if (table === REPORT_TABLE_ID.assignmentEngagement) {
                _this.props.onChangeTab(assignmentIdx);
                _this.props.setAssignmentEngagementCardAndTableSortInteraction(getProps(sortDirection, headerSelector, field));
            }
            if (table === REPORT_TABLE_ID.studentEngagement) {
                _this.props.onChangeTab(studentIdx);
                _this.props.setStudentEngagementSort(getProps(sortDirection, headerSelector, field));
            }
        };
        return _this;
    }
    EngagementHeader.prototype.render = function () {
        var _this = this;
        var _a = this.props, assignmentTypeValue = _a.assignmentTypeValue, assignmentTypeOptions = _a.assignmentTypeOptions, onSetAssignmentTypeValue = _a.onSetAssignmentTypeValue;
        return (<div className="c-cw-engagement-header">
        <div className="u-els-margin-bottom-2x u-els-margin-top-1o2 u-els-display-flex o-els-flex-layout--middle">
          <AssignmentTypeIcon type={assignmentTypeValue} showTitle={false} size="1x1o2" className="u-els-margin-right-1o2"/>
          <h2 className="u-els-text-align-inline-block  u-els-margin-right-1o2">How engaged is my class in</h2>
          <h2 className="u-els-text-align-inline-block  u-els-margin-right-1o2">
            <RadioMenu inline checkedKey={assignmentTypeValue} options={assignmentTypeOptions} onOptionChange={function (option) { return onSetAssignmentTypeValue(option); }} hideRadio ariaLabel="Assignment type"/>
          </h2>
          <h2 className="u-els-text-align-inline-block ">assignments?</h2>
        </div>
        <FlagCondition featureFlagName={FeatureFlagNames.CW_UPDATED_UI_ENABLED} trueStatement={<EngagementInsightCardList assignmentEngagement={this.props.assignmentEngagement} filteredAssignmentEngagement={this.props.filteredAssignmentEngagement} studentEngagement={this.props.studentEngagement} isAssignmentEngagementReportLoading={this.props.isAssignmentEngagementReportLoading} isStudentEngagementReportLoading={this.props.isStudentEngagementReportLoading} onLowCompletionNavigate={function () { return _this.handleLowCompletionNavigate(); }} onDisengagedStudentsSortClick={function () { return _this.handleSubTitleClick(CW_ENGAGEMENT_CARD_ID.disengagedStudents); }} onClassAverageScoreSortClick={function () { return _this.handleSubTitleClick(CW_ENGAGEMENT_CARD_ID.classAverageScore); }} onPastDueSortClick={function () { return _this.handleSubTitleClick(CW_ENGAGEMENT_CARD_ID.pastDueAssignments); }}/>} falseStatement={<div className="u-els-margin-top-2x u-els-margin-bottom-2x c-cw-engagement-header__cards">
              {this.buildCardProps().map(function (cardProp) { return (<div key={cardProp.id} className={"c-cw-engagement-header__card ".concat(cardProp.className)}>
                  <ReportInsightCard onSubTitleClick={function (id) {
                        _this.handleSubTitleClick(id);
                    }} {...cardProp}/>
                </div>); })}
            </div>}/>
      </div>);
    };
    return EngagementHeader;
}(Component));
var mapStateToProps = function (state) { return ({
    assignmentEngagement: cwSelectors.getAssignmentEngagement(state),
    studentEngagement: cwSelectors.getStudentEngagement(state),
    isAssignmentEngagementReportLoading: cwSelectors.getAssignmentEngagementReportLoading(state),
    isStudentEngagementReportLoading: cwSelectors.getStudentEngagementReportLoading(state),
    featureFlags: appSelectors.getFeatureFlags(state)
}); };
var mapDispatchToProps = function (dispatch) { return ({
    setStudentEngagementSort: function (data) { return dispatch(cwActions.setStudentEngagementSort(data)); },
    setAssignmentEngagementCardAndTableSortInteraction: function (data) { return dispatch(cwActions.setAssignmentEngagementCardAndTableSortInteraction(data)); },
    setAssignmentSummaryCardAndTableSortInteraction: function (data) { return dispatch(cwActions.setAssignmentSummaryCardAndTableSortInteraction(data)); }
}); };
export { EngagementHeader as EngagementHeaderBase };
export default connect(mapStateToProps, mapDispatchToProps)(EngagementHeader);
